import React, { useState, useEffect } from 'react'
import JobTile from '../../../components/JobTile';
import { Col, Row, Image, Container } from 'react-bootstrap';
import styled from 'styled-components';
import CompanyTile from '../../../components/CompanyTile';
import BannerImage from '../../../assets/JobBoard_Banner.png';
import { groupBy, keys } from 'lodash';

import api from '../../../services/client';

import CategoryBoard from './component/categoryboard';
import FeaturedCompanyTitle from '../../../assets/FeaturedCompanyTitle.png';
import FeaturedJobsTitle from '../../../assets/FeaturedJobsTitle.png';
import { useAuth } from '../../../auth/AuthContext';
import CompanyJobs from './component/CompanyJobs';

const Banner = styled.div`
    background-image: url(${BannerImage});
    min-height: 400px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
`;
const FeaturedJobs = styled.div`
    background-image: url(${FeaturedCompanyTitle});
    min-height: 65px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 65%;    
    margin: auto;
    @media screen and (max-width: 450px) {
        min-height: 60px;
    }
`;
function JobBoard(props) {

    const [featuredJobs, setFeaturedJobs] = useState([])
    const [featuredCompanies, setFeaturedCompanies] = useState([])
    const [allJobs, setAllJobs] = useState([])
    const { currentUser } = useAuth();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(async () => {
        if (currentUser && currentUser.Company) {
            await api.getJobsByCompanyId(currentUser.Company.CompanyId).then(result => {
                setAllJobs(result.data);
            }).catch(error => {

            });

        } else {

            await api.getAllCompaines().then(result => {
                setFeaturedCompanies(result.data);
            }).catch(error => {

            });

            // await api.getFeaturedJobs().then(result => {
            //     setFeaturedJobs(result.data);
            // }).catch(error => {
            // });

            // await api.getAllJobs().then(result => {
            //     setAllJobs(result.data);
            // }).catch(error => {
            // });
        }

    }, []);


    const jobsByCat = groupBy(allJobs, 'Category');
    return allJobs && (!currentUser?.Company) ? (
        <>
            <Banner />
            <FeaturedJobs/>
            <Container>
                
                <Row>
                    {
                        featuredCompanies.length != 0 && featuredCompanies.map((company, key) => {
                            return (
                                <div style={{ margin: ' 10px 0px'}} className='col-xs-6 col-xl-3 col-lg-3 col-md-3 col-sm-6' key={'c' + key}>
                                    <CompanyTile TileData={company} maxLine={4} key={key} />
                                </div>
                            );
                        })
                    }
                </Row>
            </Container>
            {/* <div style={{backgroundColor:'#2E3192', marginTop: '1%'}}>
         {featuredJobs.length !=0 && <>
            <div style={{marginLeft: '40%'}}><Image src={FeaturedJobsTitle} height='40px' style={{marginTop: '2%'}}/></div>
            <Row style={{width: '70%', marginLeft: '15%'}}>
                {featuredJobs.slice(0,4).map((job, key) => {
                        return (<Col style={{marginTop: '2%',marginBottom: '2%'}} key={'f'+key}>
                                    <JobTile TileData={job} maxLine={2} key={key}></JobTile>
                                </Col>);
                    })}
                
            </Row>
            </>
        }
        </div>    */}
            {/* <Container style={{marginTop:'2%', marginBottom:'5%'}}>
        {keys(jobsByCat).map((jobCat, key) => {
                        return (
                            <>
                            <CategoryBoard JobList ={jobsByCat[jobCat]}  Category={jobCat} key={key}></CategoryBoard>
                            <br />
                            </>
                        );
                    })}
            
        </Container> */}
        </>

    ) : (
        <>

            <Container style={{ marginTop: '5%' }}>
                <CompanyJobs JobList={allJobs} />
            </Container>
        </>
    )
}

JobBoard.propTypes = {

}

export default JobBoard

